<template>
  <Teleport to="body">
    <dialog ref="dialog" class="mono-contact-dialog" :class="{'mono-dark':dark}" aria-labelledby="mono-contact-title" @click="backdrop" @cancel.prevent="close">
      <button class="mono-contact-close" aria-label="Close message" @click="close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 5 14 14M19 5 5 19"/></svg></button>
      <Transition name="mono-contact-step" mode="out-in" @after-enter="focusStep">
        <div v-if="sent" key="sent" class="mono-contact-success" role="status">
          <svg viewBox="0 0 32 32" aria-hidden="true"><path d="m7 16 6 6L26 9"/></svg>
          <h2 id="mono-contact-title" ref="successTitle" tabindex="-1">Thank you.</h2>
          <p>Your message is on its way to me.</p><p>A confirmation will arrive at <span>{{sentEmail}}</span>. You can reply to it if you have anything to add.</p>
          <button class="mono-contact-done" @click="close">Done</button>
        </div>
        <div v-else key="form">
          <h2 id="mono-contact-title">Say hello.</h2><p class="mono-contact-intro">I'd be glad to hear what’s on your mind.</p>
          <form :aria-busy="sending" @submit.prevent="send">
            <label for="mono-email">Your email</label><input id="mono-email" ref="emailInput" v-model="email" required maxlength="254" type="email" autocomplete="email" placeholder="you@example.com" :disabled="sending"/>
            <label for="mono-message">Your message</label><textarea id="mono-message" v-model="message" required minlength="2" maxlength="4000" rows="4" placeholder="Leave a note..." :disabled="sending"/>
            <div class="mono-contact-trap" aria-hidden="true" inert><label for="mono-website">Website</label><input id="mono-website" v-model="website" tabindex="-1" autocomplete="off"/></div>
            <p v-if="error" class="mono-contact-error" role="alert">{{error}} <a href="mailto:whenry6688@gmail.com">email me directly</a>.</p>
            <div class="mono-contact-send"><button type="submit" :disabled="sending||!email.trim()||message.trim().length<2"><span>{{sending?'Sending...':'Send message'}}</span><span v-if="sending" class="mono-contact-spinner" aria-hidden="true"></span><svg v-else class="mono-contact-plane" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m21 3-6 18-4-8-8-4 18-6Zm0 0L11 13"/></svg></button></div>
          </form>
        </div>
      </Transition>
    </dialog>
  </Teleport>
</template>
<script>
const endpoint = 'https://henry-contact.whenry6688.workers.dev/contact';
export default {
  props:{dark:Boolean},
  data:()=>({email:'',message:'',website:'',sending:false,sent:false,sentEmail:'',error:'',submission:null}),
  beforeUnmount(){this.$refs.dialog?.close();},
  methods:{
    open(){this.returnFocus=document.activeElement;this.$refs.dialog.showModal();this.$nextTick(()=>{if(this.sent)this.$refs.successTitle?.focus({preventScroll:true});else this.$refs.emailInput?.focus({preventScroll:true});});},
    focusStep(){if(this.sent)this.$refs.successTitle?.focus({preventScroll:true});},
    close(){this.$refs.dialog.close();this.returnFocus?.focus({preventScroll:true});if(this.sent){this.sent=false;this.sentEmail='';this.submission=null;}},
    backdrop(event){if(event.target===this.$refs.dialog)this.close();},
    async send(){
      if(this.sending||!this.$refs.dialog.querySelector('form').reportValidity())return;
      const email=this.email.trim(),message=this.message.replace(/\r\n?/g,'\n').trim();
      const signature=JSON.stringify([email,message]);
      if(this.submission?.signature!==signature)this.submission={id:crypto.randomUUID(),signature};
      this.sending=true;this.error='';
      try{
        const response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},signal:AbortSignal.timeout(20000),body:JSON.stringify({id:this.submission.id,email,message,website:this.website})});
        if(response.status===429){this.error='Please wait before sending another message, or';return;}
        if(response.status===400){this.error='Please check your email and message, or';return;}
        if(!response.ok||(await response.json()).accepted!==true)throw new Error('send_failed');
        this.sentEmail=email;this.sent=true;this.message='';this.email='';
        await this.$nextTick();this.$refs.successTitle?.focus({preventScroll:true});
      }catch{this.error='I couldn’t confirm your message was sent. Please try again, or';}
      finally{this.sending=false;}
    },
  },
};
</script>
